import { apiService } from './api';
import { PaginationParams } from '../types/common';
import { CountriesResponse, Country, CreateCountryRequest, UpdateCountryRequest } from '../types/client';

class CountryService {
  async getCountries(params?: PaginationParams & { status?: 'ACTIVE' | 'INACTIVE' }): Promise<CountriesResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params?.status) queryParams.append('status', params.status);

    return apiService.get<CountriesResponse>(`/countries?${queryParams.toString()}`);
  }

  async createCountry(data: CreateCountryRequest): Promise<{ message: string; country: Country }> {
    return apiService.post<{ message: string; country: Country }>(`/countries`, data);
  }

  async updateCountry(id: string, data: UpdateCountryRequest): Promise<{ message: string; country: Country }> {
    return apiService.put<{ message: string; country: Country }>(`/countries/${id}`, data);
  }

  async deleteCountry(id: string): Promise<{ message: string }> {
    return apiService.delete<{ message: string }>(`/countries/${id}`);
  }

  async bulkUpdateCountryStatus(ids: string[], status: 'ACTIVE' | 'INACTIVE'): Promise<{ success: boolean; message: string; count: number }> {
    return apiService.post<{ success: boolean; message: string; count: number }>(`/countries/bulk-status`, { ids, status });
  }

  async exportCountries(params?: { search?: string; status?: 'ACTIVE' | 'INACTIVE'; ids?: string[] }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.ids && params.ids.length) queryParams.append('ids', params.ids.join(','));
    const baseURL = process.env.REACT_APP_API_URL || '/api';
    const response = await fetch(`${baseURL}/countries/export?${queryParams.toString()}`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    });
    if (!response.ok) throw new Error('Export failed');
    return response.blob();
  }
}

export const countryService = new CountryService();

